document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.shopify-section');

  if (!sections.length) return;

  sections.forEach((section) => {
    section.classList.add('reveal-init');
  });

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal-visible');
          obs.unobserve(entry.target); // animazione una volta sola
        }
      });
    },
    {
      threshold: 0.15,
      rootMargin: '0px 0px -50px 0px'
    }
  );

  sections.forEach((section) => {
    observer.observe(section);
  });
});